import styled from 'styled-components';

const MainStyles = styled.div`
  display: flex;
  
  flex-grow: 1;
  background-image: url("/images/mobile-main-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;

  padding: 0 20px;

  @media (min-width: 768px) {
    padding: 0 40px;
  }

  @media (min-width: 1280px) {
    background-image: url("/images/main-bg.png");

    padding: 0 0 0 160px;
  }

  @media (min-width: 1440px) {
    padding: 0 0 0 180px;
  }

  @media (min-width: 2400px) {
    padding: 0 0 0 280px;
  }

  .content {
    flex-grow: 1;
    display: grid;
    gap: 40px;

    @media (min-width: 768px) {
      gap: 80px;
    }

    @media (min-width: 1280px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 40px;
    }

    .rightPart {
      display: flex;
      align-items: flex-end;
      justify-content: center;

      img {
        width: 100%;

        @media (min-width: 1280px) {
          height: 70vh;
          width: auto;
        }
      }
    }
  }

  .imageWrapper {
    overflow: hidden;
    display: flex;

    &.inView {
      img {
        opacity: 1;
        transform: translateY(0);
      }
    }

    img {
      opacity: 0;
      transform: translateY(100%);
      transition: .6s opacity, .6s transform;
    }
  }
`;

export default MainStyles;
